<template>
	<footer class="centered">
		<div class="footer_inner">
			<div v-html="$store.state.footer"></div>
			<div class="logos_wrapper">
				<div class="logo"></div>
				<div class="kosher_logo"></div>
			</div>
		</div>
	</footer>
</template>
